import { Fieldset } from '@/common/ui/Form/Fieldset'
import { Select, SelectOption } from '@/common/ui/Form/Select'
import { Button } from '@/common/ui/Form/Button'
import { Textarea } from '@/common/ui/Form/Textarea'
import { useSupport } from '../model'

export const SupportForm = () => {
    const { register, handleSubmit, errors, onSubmit, mutation } = useSupport()

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='grid grid-cols-1 gap-6'>
            <div>
                <Fieldset label='Тема обращения' errorText={errors.subject?.message} required>
                    <Select
                        className='w-full'
                        size='lg'
                        placeholder='Выберите тему'
                        {...register('subject', {
                            required: 'Необходимо выбрать тему обращения',
                        })}
                    >
                        <SelectOption value='Проблема с заказом'>Проблема с заказом</SelectOption>
                        <SelectOption value='Оплата и возвраты'>Оплата и возвраты</SelectOption>
                        <SelectOption value='Настройка и подключение API'>Настройка и подключение API</SelectOption>
                        <SelectOption value='Жалоба или претензия'>Жалоба или претензия</SelectOption>
                        <SelectOption value='Предложение по улучшению'>Предложение по улучшению</SelectOption>
                        <SelectOption value='Другое'>Другое</SelectOption>
                    </Select>
                </Fieldset>
            </div>

            <div>
                <Fieldset label='Текст обращения' errorText={errors.message?.message} required>
                    <Textarea
                        className='w-full'
                        size='lg'
                        placeholder='Введите текст обращения'
                        {...register('message', {
                            required: 'Необходимо заполнить текст обращения',
                            minLength: {
                                value: 10,
                                message: 'Текст обращения должен содержать минимум 10 символов',
                            },
                        })}
                    />
                </Fieldset>
            </div>

            {errors.root && <div className='text-error text-sm text-center'>{errors.root.message}</div>}

            {mutation.isSuccess && (
                <div className='text-success text-sm text-center'>Ваш запрос успешно отправлен!</div>
            )}

            <div className='actions'>
                <Button variant='filled' emphasis='accent' size='lg' type='submit' disabled={mutation.isPending}>
                    {mutation.isPending ? <span className='loading loading-spinner loading-xs mr-2'></span> : null}
                    Отправить
                </Button>
            </div>
        </form>
    )
}
